<template>
    <v-dialog v-model="isOpen" max-width="500" fullscreen>
        <v-card>
            <v-card-title class="headline">
                <v-row>
                    <v-col cols="10" class="align-self-center">
                        <span class="offer-text--bold">
                            {{ title }}
                        </span>
                    </v-col>
                    <v-spacer></v-spacer>
                    <v-col cols="2" class="align-self-center">
                        <v-btn color="red" icon @click="onClose()"
                            ><v-icon>mdi-close</v-icon></v-btn
                        >
                    </v-col>
                </v-row>
            </v-card-title>
            <slot name="body"></slot>
        </v-card>
    </v-dialog>
</template>

<script>
export default {
    name: "FullscreenModal",
    props: ["isOpen", "title", "onClose"],
};
</script>

<style scoped></style>
